(function($) {

  $(function() {

    $('#user_login').attr('placeholder', 'E-mail')
    $('#user_pass').attr('placeholder', 'Contraseña')
    $('#wp-submit').attr('value', 'Acceder')

    $('#backtoblog').remove()
    $('.privacy-policy-page-link').remove()

    const $lostpaswordform = $('#lostpasswordform')
    if($lostpaswordform.length) {

      $('#wp-submit').attr('value', 'Solicitar')      
    }

    $('#login').wrapInner('<div class="WrapperOuter"><div class="Wrapper"></div></div>')

    /**
    fetch(`wp-json/playmotivcloud/core/v4/contents/96`)
    .then( result => {

      result.json()
      .then(content => {

        $('body')
        .append('<div id="login-cover">' + content.content + '</div>')

        const $slidecontainers = $('#login-cover .wp-block-playmotivcloud-slide .wp-block-cover__inner-container')

        $slidecontainers
        .append(`
          <div class="points">...</div>
          <div class="entrar">Entrar</div>
          <div class="saltar">Saltar</div>
        `)
      })
    })
    */
  })

})(jQuery)